import React from 'react';
import classNames from 'classnames';
import withUnit from '../utils/with-unit';
import containsInstanceOf from '../common/utils/contains-instance-of';
import Render from '../render';
import PanelLeft from './panel-left';
import PanelRight from './panel-right';

const defaultStyles = {};

// @ts-ignore TS(2322): Type 'null' is not assignable to type '{ current?:... Remove this comment to see the full error message
function Panel({
  height = 'auto',
  align = 'top',
  theme = 'white',
  scrollable = false,
  corners = 'rounded',
  children,
  className = '',
  style = defaultStyles,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ current?: any; }'.
  rootRef = null,
  draggablePanel = false,
  ...otherProps
}) {
  const classes = classNames(
    'ws-panel',
    `ws-panel--theme-${theme}`,
    `ws-panel--align-${align}`,
    `ws-panel--corners-${corners}`,
    className,
    {
      'ws-panel--scrollable': scrollable,
      'ws-panel--draggable': draggablePanel,
    }
  );

  const hasLeftRightPanel =
    containsInstanceOf(PanelLeft, children) || containsInstanceOf(PanelRight, children);

  return (
    <div
      className={classes}
      style={{ ...style, height: withUnit(height) }}
      // @ts-ignore TS(2322): Type '{ current?: any; }' is not assignable to typ... Remove this comment to see the full error message
      ref={rootRef}
      {...otherProps}
    >
      <Render if={draggablePanel}>
        <div className="drag-element" />
      </Render>
      {/* @ts-ignore TS(2322): Type 'ReactNode' is not assignable to type 'string... Remove this comment to see the full error message */}
      <Render if={hasLeftRightPanel}>{children}</Render>
      <Render if={!hasLeftRightPanel}>
        <div className="ws-panel__content">{children}</div>
      </Render>
    </div>
  );
}

export default Panel;
